<div class="encabezado">
  <!-- Tooltip container removed: replaced by SweetAlert popups -->

  <div class="col-4 getBack" *ngIf="!campaignTable">
    <a routerLink="/reports" class="getBack">
      <span
        ><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}
      </span></a
    >
  </div>

  <div class="col-4 getBack" *ngIf="campaignTable">
    <a (click)="goBackTable()"
      ><span
        ><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}
      </span></a
    >
  </div>
  <div class="">
    <div class="">
      <div>
        <h3 class="">
          {{ subType != "" ? ("settings.buttons." + subType | translate) : "" }}
        </h3>
      </div>
      <div class="d-flex align-items-center">
        <h5 class="titulo1">
          {{ "reports." + type | translate }} {{ campaignName }}
        </h5>
      </div>
    </div>
  </div>

  <div class="filter-content row">
    <app-filter
      [ladata]="ladata"
      (filterChanged)="filterChanged($event)"
      type="evolution"
      [broker]="broker"
      [campaignTable]="campaignTable"
    ></app-filter>
  </div>

  <!-- <div class="filterText" *ngIf="showFilterText">
    <h4>{{ "reports.labels.result_title" | translate: { stage:
      stage,start_date:stage_start_date | formatDatePipe ,end_date:stage_end_date | formatDatePipe } }} </h4>
  </div>
 -->

  <div class="row mb-4 div-kpis" *ngIf="showKpis">
    <div class="row">
      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.units" | translate }}
          </p>
          <p class="count">{{ kpis.units }}</p>
        </div>
      </div>
      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.available_units" | translate }}
            <span class="info-icon" tabindex="0">
              <i class="icon-notification"></i>
              <span class="tooltip">{{
                "inputs.i.available_units" | translate
              }}</span>
            </span>
          </p>
          <p class="count">{{ kpis.available_units }}</p>
        </div>
      </div>
      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.virtual_available_units" | translate }}
            <span class="info-icon" tabindex="0">
              <i class="icon-notification"></i>
              <span class="tooltip">{{
                "inputs.i.virtual_available_units" | translate
              }}</span>
            </span>
          </p>
          <p class="count">{{ kpis.virtual_available_units }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2 offset-1">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.sent" | translate }}
          </p>
          <span class="count d-flex align-items-center gap-2"
            >{{ kpis.sent.count }}
            <p class="porcentaje">{{ kpis.sent.pct_units }}</p>
          </span>
        </div>
      </div>
      <div class="col-2">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.risk_started" | translate }}
          </p>
          <span class="count d-flex align-items-center gap-2"
            >{{ kpis.risk_started.count }}
            <p class="porcentaje">{{ kpis.risk_started.pct_units }}</p>
            <i class="icon-info-circle info-icon" tabindex="0">
              <span class="tooltip">{{
                "inputs.i.risk_started" | translate
              }}</span></i
            >
          </span>
        </div>
      </div>
      <div class="col-2">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.risk_approved" | translate }}
          </p>
          <span class="count d-flex align-items-center gap-2"
            >{{ kpis.risk_approved.count }}
            <p class="porcentaje">{{ kpis.risk_approved.pct_units }}</p>
          </span>
        </div>
      </div>
      <div class="col-2">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.contract_signed" | translate }}
          </p>
          <span class="count d-flex align-items-center gap-2"
            >{{ kpis.contract_signed.count }}
            <p class="porcentaje">{{ kpis.contract_signed.pct_units }}</p>
          </span>
        </div>
      </div>
      <div class="col-2">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.contract_accepted" | translate }}
          </p>
          <span class="count d-flex align-items-center gap-2"
            >{{ kpis.contract_accepted.count }}
            <p class="porcentaje">{{ kpis.contract_accepted.pct_units }}</p>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.risk_rate" | translate }}
            <span class="info-icon" tabindex="0">
              <i class="icon-notification"></i>
              <span class="tooltip"
                >{{ "inputs.i.risk_started_vs_sent" | translate }}
              </span>
            </span>
          </p>
          <p class="count d-flex align-items-center gap-2">
            {{ kpis.risk_rate }}
          </p>
        </div>
      </div>

      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.approval_rate" | translate }}
            <span class="info-icon" tabindex="0">
              <i class="icon-notification"></i>
              <span class="tooltip">{{
                "inputs.i.aprovado_iniciado" | translate
              }}</span>
            </span>
          </p>
          <p class="count d-flex align-items-center gap-2">
            {{ kpis.approval_rate }}
          </p>
        </div>
      </div>
      <div class="col-4">
        <div
          class="border border-gray-300 rounded-md shadow-sm p-4 bg-white kpis"
        >
          <!-- Título -->
          <p class="text-sm text-black-400 mb-2">
            {{ "inputs.signature_rate" | translate }}
            <span class="info-icon" tabindex="0">
              <i class="icon-notification"></i>
              <span class="tooltip"
                >{{ "inputs.i.firmado_aprovado" | translate }}
              </span>
            </span>
          </p>
          <p class="count d-flex align-items-center gap-2">
            {{ kpis.signature_rate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex d-flex-end-gap">
    <button
      class="btn btn-secundario"
      type="button"
      (click)="openExportOptions()"
    >
      {{ "buttons.export" | translate }} <i class="icon-download"></i>
    </button>
  </div>

  <div *ngIf="dataSource.data.length">
    <div class="tabla_evo" [hidden]="campaignTable">
      <table
        mat-table
        class="full-width-table"
        matSort
        aria-label="Brands"
        multiTemplateDataRows
        [dataSource]="dataSource"
      >
        <!-- Columna de Mes/Año -->
        <ng-container matColumnDef="reference">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla cell-start"
            (click)="onSortChange('reference')"
          >
            {{ "inputs.reference" | translate }}
            <i [ngClass]="getDirection(sortDirection)"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <a (click)="onCampaignClick(row.reference, row.name)">{{
              row.campaign_reference
            }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla cell-start"
            (click)="onSortChange('name')"
          >
            {{ "inputs.name" | translate }}
            <i [ngClass]="getDirection(sortDirection)"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <a (click)="onCampaignClick(row.reference, row.name)">{{
              row.name
            }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="start">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla cell-start"
          >
            {{ "inputs.start" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.start_date }}</td>
        </ng-container>

        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.units" | translate }}
          </th>

          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column">
              <div class="column-list d-flex align-items-center">
                <span
                  *ngIf="row?.virtual_available_units"
                  class="badge bg-info"
                >
                  {{ row?.virtual_available_units }}</span
                >
                <span
                  *ngIf="row?.virtual_available_units"
                  class="text-secondary text-sm label-unit"
                >
                  {{ "inputs.virtuals" | translate }}</span
                >
                <span *ngIf="row?.available_units">{{
                  row.available_units
                }}</span>
                <span
                  *ngIf="row?.available_units"
                  class="text-secondary text-sm label-unit"
                >
                  {{ "inputs.availables" | translate }}</span
                >
                <span *ngIf="row?.campaign_units">{{
                  row.campaign_units
                }}</span>
                <span
                  *ngIf="row?.campaign_units"
                  class="text-secondary text-sm label-unit-centered"
                >
                  {{ "inputs.totals" | translate }}</span
                >
              </div>
            </div>
          </td>

          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            {{ row.virtual_available_units }}
          </td>
          <td mat-cell *matCellDef="let row">{{ row.campaign_units }}</td>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            {{ row.available_units }}
          </td>
        </ng-container>

        <!-- Columna Sent -->
        <ng-container matColumnDef="sent">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.sent" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            {{ row.sent }}
            <span *ngIf="row?.ratio_sent" class="secondary-text">
              ({{ row?.ratio_sent }})
              <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup('sent',row?.sent_real_stages)"
              >
                <i class="icon-notification"></i>
              </span>
            </span>
          </td>
        </ng-container>

        <!-- Columna Risk Started -->
        <ng-container matColumnDef="risk_started">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_started" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.sent">
              {{ row.risk_started }}
              <span *ngIf="row?.ratio_risk_started" class="secondary-text">
                ({{ row?.ratio_risk_started }})
                <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup('risk_started',row?.risk_started_real_stages)"
              >
                <i class="icon-notification"></i>
              </span>
              </span>
              </span>
            <span *ngIf="!row?.sent"> - </span>
          </td>
        </ng-container>

        <!-- Columna Risk Approved -->
        <ng-container matColumnDef="risk_approved">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_approved" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_started"
              >{{ row.risk_approved }}
              <span *ngIf="row?.ratio_risk_approved" class="secondary-text">
                ({{ row?.ratio_risk_approved }})
                 <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup('risk_approved',row?.risk_approved_real_stages)"
              >
                <i class="icon-notification"></i>
              </span></span
              ></span
            ><span *ngIf="!row?.risk_started"> - </span>
          </td>
        </ng-container>

        <!-- Columna Contract Signed -->
        <ng-container matColumnDef="contract_signed">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_signed" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_signed }}
              <span *ngIf="row?.ratio_contract_signed" class="secondary-text">
                ({{ row?.ratio_contract_signed }})
                 <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup('contract_signed',row?.contract_signed_real_stages)"
              >
                <i class="icon-notification"></i>
              </span>
              </span></span
            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="contract_accepted">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_accepted" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_accepted }}
              <span *ngIf="row?.ratio_contract_accepted" class="secondary-text">
                ({{ row?.ratio_contract_accepted }})
                 <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup(  'contract_accepted',row?.contract_accepted_real_stages)"
              >
                <i class="icon-notification"></i>
              </span>
              </span>
              </span            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <!-- Columna Vehicle Delivered -->
        <ng-container matColumnDef="vehicle_delivered">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.vehicle_delivered" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.contract_signed"
              >{{ row.vehicle_delivered }}
              <span *ngIf="row?.ratio_vehicle_delivered" class="secondary-text">
                ({{ row?.ratio_vehicle_delivered }})
                 <span
                class="info-icon"
                tabindex="0"
                (click)="showStagePopup('vehicle_delivered',row?.vehicle_delivered_real_stages)"
              >
                <i class="icon-notification"></i>
              </span></span
              ></span
            ><span *ngIf="!row?.contract_signed"> - </span>
          </td>
        </ng-container>

        <!-- Fila de Encabezado -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Filas de Datos -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            class="clickable-row"
            title="Consultar más detalles"
            (click)="onCampaignClick(row.reference, row.name)"></tr>
      </table>

      <!-- Paginador -->
      <mat-paginator
        [pageSize]="5"
        [pageSizeOptions]="[5, 10, 20]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
  <div [hidden]="!campaignTable">
    <div class="tabla_evo_campaign" *ngIf="dataSource3.data.length">
      <table
        mat-table
        class="full-width-table"
        matSort
        aria-label="Brands"
        multiTemplateDataRows
        [dataSource]="dataSource3"
      >
        <!-- Columna de Mes/Año -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla cell-start"
            (click)="onSortChange3('month')"
          >
            {{ "inputs.month1" | translate }}
            <i [ngClass]="getDirection(sortDirection3)"></i>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.date }}</td>
        </ng-container>

        <!-- Columna Sent -->
        <ng-container matColumnDef="sent">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.sent" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            {{ row.sent }}
            <span *ngIf="row?.ratio_sent" class="secondary-text">
              ({{ row?.ratio_sent }})</span
            >
          </td>
        </ng-container>

        <!-- Columna Risk Started -->
        <ng-container matColumnDef="risk_started">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_started" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.sent"
              >{{ row.risk_started }}
              <span *ngIf="row?.ratio_risk_started" class="secondary-text">
                ({{ row?.ratio_risk_started }})</span
              ></span
            ><span *ngIf="!row?.sent"> - </span>
          </td>
        </ng-container>

        <!-- Columna Risk Approved -->
        <ng-container matColumnDef="risk_approved">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_approved" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_started"
              >{{ row.risk_approved }}
              <span *ngIf="row?.ratio_risk_approved" class="secondary-text">
                ({{ row?.ratio_risk_approved }})</span
              ></span
            ><span *ngIf="!row?.risk_started"> - </span>
          </td>
        </ng-container>

        <!-- Columna Contract Signed -->
        <ng-container matColumnDef="contract_signed">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_signed" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_signed }}
              <span *ngIf="row?.ratio_contract_signed" class="secondary-text">
                ({{ row?.ratio_contract_signed }})</span
              ></span
            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="contract_accepted">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_accepted" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_accepted }}
              <span *ngIf="row?.ratio_contract_accepted" class="secondary-text">
                ({{ row?.ratio_contract_accepted }})</span
              ></span
            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <!-- Columna Vehicle Delivered -->
        <ng-container matColumnDef="vehicle_delivered">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.vehicle_delivered" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.contract_signed"
              >{{ row.vehicle_delivered }}
              <span *ngIf="row?.ratio_vehicle_delivered" class="secondary-text">
                ({{ row?.ratio_vehicle_delivered }})</span
              ></span
            ><span *ngIf="!row?.contract_signed"> - </span>
          </td>
        </ng-container>

        <!-- Fila de Encabezado -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>

        <!-- Filas de Datos -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
      </table>

      <!-- Paginador -->
      <!-- <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)">
      </mat-paginator> -->
    </div>

    <div class="tabla_evo_campaign" *ngIf="dataSource2.data.length">
      <table
        mat-table
        class="full-width-table"
        matSort
        aria-label="Brands"
        multiTemplateDataRows
        [dataSource]="dataSource2"
      >
        <!-- Columna de Mes/Año -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla cell-start"
          >
            {{ "inputs.broker" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.broker }}</td>
        </ng-container>

        <!-- Columna Sent -->
        <ng-container matColumnDef="sent">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.sent" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            {{ row.sent }}
            <span *ngIf="row?.ratio_sent" class="secondary-text">
              ({{ row?.ratio_sent }})</span
            >
          </td>
        </ng-container>

        <!-- Columna Risk Started -->
        <ng-container matColumnDef="risk_started">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_started" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.sent">
              {{ row.risk_started }}
              <span *ngIf="row?.ratio_risk_started" class="secondary-text">
                ({{ row?.ratio_risk_started }})</span
              ></span
            ><span *ngIf="!row?.sent"> - </span>
          </td>
        </ng-container>
        <!-- <span *ngIf="row?.contract_signed">{{ row.vehicle_delivered }} <span *ngIf="row?.ratio_vehicle_delivered"
            class="secondary-text">
            ({{ row?.ratio_vehicle_delivered }})</span></span><span *ngIf="!row?.contract_signed"> - </span></td> -->

        <!-- Columna Risk Approved -->
        <ng-container matColumnDef="risk_approved">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.risk_approved" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_started"
              >{{ row.risk_approved }}
              <span *ngIf="row?.ratio_risk_approved" class="secondary-text">
                ({{ row?.ratio_risk_approved }})</span
              ></span
            ><span *ngIf="!row?.risk_started"> - </span>
          </td>
        </ng-container>

        <!-- Columna Contract Signed -->
        <ng-container matColumnDef="contract_signed">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_signed" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_signed }}
              <span *ngIf="row?.ratio_contract_signed" class="secondary-text">
                ({{ row?.ratio_contract_signed }})</span
              ></span
            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <!-- Columna Vehicle Delivered -->
        <ng-container matColumnDef="vehicle_delivered">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.vehicle_delivered" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.contract_signed">
              {{ row.vehicle_delivered }}
              <span *ngIf="row?.ratio_vehicle_delivered" class="secondary-text">
                ({{ row?.ratio_vehicle_delivered }})</span
              ></span
            ><span *ngIf="!row?.contract_signed"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="contract_accepted">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.contract_accepted" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="cell-center"
          >
            <span *ngIf="row?.risk_approved"
              >{{ row.contract_accepted }}
              <span *ngIf="row?.ratio_contract_accepted" class="secondary-text">
                ({{ row?.ratio_contract_accepted }})</span
              ></span
            ><span *ngIf="!row?.risk_approved"> - </span>
          </td>
        </ng-container>

        <!-- Fila de Encabezado -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>

        <!-- Filas de Datos -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
      </table>

      <!-- Paginador -->
      <!-- s -->
    </div>
  </div>
  <!--  <canvas id="myLineChart"></canvas> -->
</div>

<div class="overlay" *ngIf="showForm"></div>
